import * as angular from 'angular';

import { ComponentDefinition } from '../../models';

class UserMiniDisplayController implements angular.IComponentController {
    isLoading: boolean;
    loadingMessage: string;

    readonly item: any; // Type to be determined
    
    static $inject = [];
}

export const wtUserMiniDisplay: ComponentDefinition = {
    componentId: 'wtUserMiniDisplay',
    controller: UserMiniDisplayController,
    template: require('./userMiniDisplay.component.html'),
    controllerAs: 'vm',
    bindings: {
        item: '<'
    }
};
